import type { CommentMentionContext } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import type {
	CommandConstructor,
	CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export interface StartBackgroundAgentConversationCommandProperties extends CommandProperties {
	prompt: string;
	agentId: string;
	/** Account identity for edit attribution; agentId is the Studio ID used for routing. */
	agentIdentityAccountId?: string;
	/** Agent identity metadata used to attribute background comment updates. */
	agentName?: string;
	agentNamedId?: string | null;
	isThirdPartyAgent?: boolean;
	productKey?: string;
	source: string;
	name: string;
	sourceId: string;
	tags: string[];
	commentMentionContext?: CommentMentionContext;
	useCurrentPageContext: boolean;
	/** Content whose context should be read instead of the currently active document. */
	contentId?: string;
}

/**
 * Start a persisted agent conversation without selecting Chat.
 * A true response acknowledges ownership, not completion; the receiver owns subsequent fallback.
 * False means execution did not start. Callers must not retry ambiguous delivery failures.
 */
export const StartBackgroundAgentConversationCommand: CommandConstructor<
	StartBackgroundAgentConversationCommandProperties,
	boolean
> = createCommand<StartBackgroundAgentConversationCommandProperties, boolean>(
	'start-background-agent-conversation-command',
);
